import React from "react";
import { Box } from "@mui/material";
import { useAuth } from "../../../contexts/AuthContext";
import TeacherOnboardingVideos from "../../../components/teacher/TeacherOnboardingVideos";

/**
 * Teacher onboarding (videos and progress) for the teacher shell.
 * Reuses the same component as the legacy dashboard.
 */
const TeacherOnboarding = () => {
	const { user, supabase } = useAuth();

	if (!user) {
		return null;
	}

	return (
		<Box>
			<TeacherOnboardingVideos supabase={supabase} user={user} />
			<Box
				sx={{
					mt: 3,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 1.25,
					py: 1,
				}}>
				<img
					src="/logo.png"
					alt="Funmiyo"
					style={{ height: 40, width: "auto", objectFit: "contain" }}
				/>
			</Box>
		</Box>
	);
};

export default TeacherOnboarding;
